module.exports = __webpack_public_path__ + "img/9788996995999.eb1f3713.jpg";